<p>Wie wollen Sie mit Amazon Pay bezahlen?</p>
<div id="AmazonPayButton"></div>
